import { ResetState } from './types';
// profile/mutations.ts
import { MutationTree } from 'vuex';
import { ProfileState, User } from './types';

export const mutations: MutationTree<ProfileState> = {
    profileLoaded(state, payload: User) {
        state.error = false;
        state.user = payload;
    },
    profileError(state) {
        state.error = true;
        state.user = undefined;
    },
    registerComplete(state, payload: User) {
        state.error = false;
        state.user = payload;
    },
    registerError(state, error) {
        state.error = true;
        state.errorMessage = error;
        state.user = undefined;
    },
    profileDataUpdate(state, newCanvasData) {
        state.user!.canvasData = newCanvasData;
    },
    resetComplete(state, resetResult) {
        state.reset = resetResult;
    },
    resetError(state, resetResult) {
        state.reset = { mail: '', error: true, resetMessage: resetResult };
        state.reset!.error = true;
        state.reset!.resetMessage = resetResult;
    },
    setNewOrgInfo(state, payload: string) {
        state.error = false;
    },
    setNewProfileInfo(state, payload: string) {
        state.error = false;
    },
};
